import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { baseURL } from '../../../constants/applicationConstants.js';
import { Loader } from '../../common/loader/loader.jsx';
import OffersJsx from './offers.jsx'


export default class Offers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            subCategoryData: null,

            keyword: null,
            selectedCategoryId: null,
            subCategories: [],
            categories: [],
            checkedCats: [],
            checkedSubCats: [],
            oldest: false,

            allOffersData: null,
            overallOffers: null,
            topOffers: null,
            isProcessing: false,

            formSubmitButtonDisable: true,
            isLoading: false,
            selectAll: false,
            expertData: [],
            page: 1,
            totalSubCategories: "",
            disableSelectAll: true,
            showSort:false,
            showFilter:false

        }
    }


    componentDidMount = () => {
        const categoryIdFromPev = localStorage.getItem("selectCategory");
        const keywordFromUrl = this.props.match.params.type;
    
        this.getTopOffers();
        this.getAllFeauturedOffersData(keywordFromUrl);
        this.getcategorySubcategory(true);
    
        setTimeout(() => {
            categoryIdFromPev ? this.checkCategoryFromPrevious() : this.selectAllIds()
        }, 1000);
    
        if (keywordFromUrl) {
            this.setState({ keyword: keywordFromUrl }, () => {
            });
        }
        this.props.match.params.keyword && this.fetchSearchData(this.props.match.params.keyword);

    }
    



    onPaginationButtonClick = (page) => {
        document.querySelector(".sortingdiv").scrollIntoView();
        this.setState({ page: page })
    }

    getcategorySubcategory = (firstFetch=false) => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const enrichedData = res.data.data.map(category => ({
                ...category,
                subInstitutionCategories: category.subInstitutionCategories?.map(sub => ({
                    ...sub,
                    parentInstitutionCategoryId: category.institutionCategoryId // 👈 Add parent ref
                })) || []
            }));

            this.setState({ categoryData: enrichedData, isLoading: false });
            // Calculate the total number of subInstitutionCategories
            const totalSubCategories = this.state.categoryData?.reduce((acc, category) => {
                return acc + (category.subInstitutionCategories ? category.subInstitutionCategories.length : 0);
            }, 0);

            // Set the totalSubCategories in state
            this.setState({ totalSubCategories });
        }).then(res => {
            if(firstFetch)
            {
                this.selectAllIds()
            }
        })
    }

    hitOldest = (action) => {

        this.setState({ oldest: action, isProcessing: true, page: 1 })
        // this.props.history.replace('/')
        // this.props.history.push(`/offers`)
        setTimeout(() => {
            this.getAllFeauturedOffersData(this.state.keyword)
            this.selectAllIds()
        }, 500);
    }
    getAllFeauturedOffersData = (search) => {
        const selectedType = this.props.match.params.type;

        this.setState({ isProcessing: true })
        axios.get(`${baseURL}/search-offers?sortBy=${this.state.oldest ? "expired" : "latest"}&search=${search || selectedType || ''}`).then(res => {
            this.setState({ allOffersData: res.data.data, overallOffers: res.data.data, isProcessing: false, selectAll: true })
        })

    }

    selectAllHit = (e) => {
        const { checked } = e.target
        if (!checked) {
            this.setState({ selectAll: false })
        } else {
            this.setState({ selectAll: true })
        }
        if (checked) {
            this.setState({ allOffersData: this.state.overallOffers, keyword: "", disableSelectAll: true })
            this.selectAllIds()
        }
    }

    searchOfferByKeyword = (e) => {
        const data = e.target.value
        this.setState({ keyword: data })
        if (data === '') {
            this.setState({ page: 1 })
            this.props.history.push(`/offers`)
            setTimeout(() => {
                this.getAllFeauturedOffersData()

            }, 500);
            this.selectAllIds()

        }

    }

    hitSearch = () => {

        this.props.history.replace('/')
        this.props.history.push(`/offers/${this.state.keyword}`)
        this.setState({ page: 1 })

        this.getAllFeauturedOffersData(this.state.keyword)
        this.selectAllIds()
    }

    fetchSearchData = (data) => {

        axios.get(`${baseURL}/search-content?keyword=${data}`).then(res => {
            this.setState({ allOffersData: res.data.data.offers, overallOffers: res.data.data.offers, isProcessing: false })
        })
    }


    getTopOffers = () => {
        this.setState({ isProcessing: true })
        axios.get(`${baseURL}/topOffers`).then(res => {
            this.setState({ topOffers: res.data.data, isProcessing: false })
        })
    }


    onCatgoryClick = (value) => {
        const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId === Number(value))

        this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
    }

    // filter all selected id
    selectAllIds = () => {
        localStorage.removeItem("selectCategory")
        const institutionCategoryIds = this.state.categoryData?.map(category => category.institutionCategoryId);
        this.setState({ categories: institutionCategoryIds })

        // Extract sub-institution category IDs as well
        this.state.categoryData?.forEach(category => {
            if (category?.subInstitutionCategories) {
                const subIds = category?.subInstitutionCategories?.map(subCategory => subCategory.institutionCategoryId);
                // institutionCategoryIds.push(...subIds);
                this.setState(prevState => ({
                    subCategories: [...prevState.subCategories, ...subIds] // Spread existing items and add new items
                }));
                // this.setState({ subCategories: ...subIds })

            }
        });

        this.setState({ institutionCategoryIds });
    }


    filterCatData = () => {
        const catDataFiltered = this.state.overallOffers.filter(offer =>
            this.state.subCategories.includes(offer.institutionSubCategoryId)
        );
        this.setState({ allOffersData: catDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }

    }
    filterSubData = () => {
        const subCatDataFiltered = this.state.overallOffers.filter(offer =>
            this.state.subCategories.includes(offer.institutionSubCategoryId)

        );
        this.setState({ allOffersData: subCatDataFiltered })
        if (this.state.subCategories.length === 0) {
            this.setState({ allOffersData: this.state.overallOffers, selectAll: true })
            this.selectAllIds()

        }

    }


    selectCategory = (data, e) => {
        const { checked } = e.target;
        const categoryId = data.institutionCategoryId;
        const subIds = data.subInstitutionCategories.map(sub => sub.institutionCategoryId);

        let updatedCategories = [...this.state.categories];
        let updatedSubCategories = [...this.state.subCategories];

        if (checked) {
            if (!updatedCategories.includes(categoryId)) updatedCategories.push(categoryId);
            subIds.forEach(subId => {
                if (!updatedSubCategories.includes(subId)) {
                    updatedSubCategories.push(subId);
                }
            });
        } else {
            updatedCategories = updatedCategories.filter(id => id !== categoryId);
            updatedSubCategories = updatedSubCategories.filter(id => !subIds.includes(id));
        }

        this.setState({
            categories: updatedCategories,
            subCategories: updatedSubCategories,
            selectAll: false,
            disableSelectAll: false,
            page: 1
        }, () => {
            this.filterCatData();
            this.triggerSelectAll();
        });
    };


    checkCategoryFromPrevious = () => {
        const categoryIdFromPev = localStorage.getItem("selectCategory");
        this.setState({ selectAll: false })
        if (categoryIdFromPev) {
            // Find the category in categoryData that matches the category ID 
            const selectedCategory = this.state.categoryData.find(

                category => category.institutionCategoryId.toString() === categoryIdFromPev

            );


            if (selectedCategory) {
                // Select this category and its subcategories
                this.selectCategory1(selectedCategory);
            }
        }
    }
    selectCategory1 = (selectedCategory) => {
        const institutionCategoryIds = selectedCategory.subInstitutionCategories.map(subCategory => subCategory.institutionCategoryId);

        // Add the category and its subcategories to the state
        this.setState(prevState => ({
            subCategories: [...prevState.subCategories, ...institutionCategoryIds],
            categories: [...prevState.categories, selectedCategory.institutionCategoryId]
        }));

        // Optionally trigger a filtering or update
        setTimeout(() => {
            this.filterCatData();
        }, 500);
    }


    handleCheckboxChange = (id) => (event) => {
        if (event.target.checked) {
            // Add ID to the selected array if not already present
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.includes(id)
                    ? prevState.selectedIds
                    : [...prevState.selectedIds, id]
            }));
        } else {
            // Remove ID from the selected array when unchecked
            this.setState((prevState) => ({
                selectedIds: prevState.selectedIds.filter((selectedId) => selectedId !== id)
            }));
        }
    };

    selectSubCategory = (data) => {
        const subCategoryId = data.institutionCategoryId;
        const parentCategoryId = data.parentInstitutionCategoryId;
    
        let updatedSubCategories = [...this.state.subCategories];
    
        // Toggle subcategory selection
        if (updatedSubCategories.includes(subCategoryId)) {
            updatedSubCategories = updatedSubCategories.filter(id => id !== subCategoryId);
        } else {
            updatedSubCategories.push(subCategoryId);
        }
    
        // Find all subcategories for the parent
        const parent = this.state.categoryData.find(cat => cat.institutionCategoryId === parentCategoryId);
        const allSubIds = parent?.subInstitutionCategories.map(sub => sub.institutionCategoryId) || [];
    
        // Determine if all subcategories are selected
        const allSelected = allSubIds.every(id => updatedSubCategories.includes(id));
    
        // Determine if all subcategories are unchecked
        const noneSelected = allSubIds.every(id => !updatedSubCategories.includes(id));
    
        let updatedCategories = [...this.state.categories];
    
        // Update the parent category checkbox if all subcategories are selected
        if (allSelected) {
            // If all subcategories are selected, ensure the parent category is selected
            if (!updatedCategories.includes(parentCategoryId)) {
                updatedCategories.push(parentCategoryId);
            }
        } else if (noneSelected) {
            // If all subcategories are unchecked, unselect the parent category
            updatedCategories = updatedCategories.filter(id => id !== parentCategoryId);
        }
    
        this.setState({
            subCategories: updatedSubCategories,
            categories: updatedCategories,
            selectAll: false,
            disableSelectAll: false,
            page: 1
        }, () => {
            this.filterSubData();
            this.triggerSelectAll();
        });
    };
    

    triggerSelectAll = () => {
        setTimeout(() => {
            const uniqueData = new Set(this.state.subCategories);

            // Get the length of the unique data
            const uniqueCount = uniqueData.size;

            if (uniqueCount >= this.state.totalSubCategories) {
                this.setState({ selectAll: true })
            }
            if (uniqueCount === this.state.totalSubCategories) {
                this.setState({ disableSelectAll: true })

            }
        }, 500);

    }

toggleDropDownSort = (action) =>{
    this.setState({showFilterL:action})
}

    render() {

        return (
            <div>
                <OffersJsx
                    subCategories={this.state.subCategories}
                    categories={this.state.categories}
                    searchOfferByKeyword={this.searchOfferByKeyword}
                    hitSearch={this.hitSearch}
                    selectAllHit={this.selectAllHit}
                    keyword={this.state.keyword}
                    getAllFeauturedOffersData={this.getAllFeauturedOffersData}

                    topOffers={this.state.topOffers}

                    allOffersData={this.state.allOffersData}
                    oldest={this.state.oldest}
                    hitOldest={this.hitOldest}
                    categoryData={this.state.categoryData}
                    subCategoryData={this.state.subCategoryData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    page={this.state.page}
                    selectCategory={this.selectCategory}
                    selectSubCategory={this.selectSubCategory}
                    selectAll={this.state.selectAll}
                    disableSelectAll={this.state.disableSelectAll}
                    showSort={this.state.showSort}
                    toggleDropDownSort={this.toggleDropDownSort}
                    showFilter={this.state.showFilter}
                />
                {this.state.isProcessing && <Loader />}
            </div>
        )
    }
}